import { styled } from '@mui/material/styles';
import { Box, IconButton, Typography } from '@mui/material';

export const EventsSectionContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: '0 5%',
  [theme.breakpoints.down('md')]: {
    padding: '0 3%',
  },
}))

export const CarouselContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '50%',
  maxWidth: '600px',
  height: '50%',
  maxHeight: '400px',
  overflow: 'hidden',
  borderRadius: '8px',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',
  flexShrink: 0,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: '100%',
    order: 2,
  },
}))

export const CarouselImage = styled('img')({
  width: '100%',
  height: '100%',
  display: 'block',
  objectFit: 'cover'
})

export const CarouselOverlay = styled(Box)({
  position: 'absolute',
  bottom: '10px',
  left: '10px',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  color: '#fff',
  padding: '5px 10px',
  borderRadius: '4px',
})

export const CarouselWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
  paddingTop: '5%',
  paddingBottom: '5%',
  [theme.breakpoints.down('md')]: {
    paddingTop: '8%',
    paddingBottom: '8%',
  },
}))

export const EventTitle = styled(Typography)(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginBottom: '20px',
  textAlign: 'center',
}))

export const DesktopEventTitle = styled(EventTitle)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))

export const EventDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.primary.dark,
  maxWidth: '500px',
  lineHeight: 1.7,
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    maxWidth: '100%',
  },
}))

export const ContentRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'side',
})<{ side?: 'left' | 'right' }>(({ theme, side }) => ({
  display: 'flex',
  flexDirection: side === 'left' ? 'row' : 'row-reverse',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '40px',
  width: '100%',
  flexWrap: 'wrap',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '20px',
  },
}));

export const MobileTitle = styled(Box)(({ theme }) => ({
  display: 'none',
  width: '100%',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'block',
    order: 1,
  },
}));

export const TextBlock = styled(Box)(({ theme }) => ({
  flex: '1',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '500px',
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
    maxWidth: '100%',
    padding: '0 15px',
    order: 3,
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'white',
  zIndex: 10,
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  borderRadius: '12px',
  boxShadow: 'rgba(0, 0, 0, 1.0)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    cursor: 'pointer',
  },
}));